/**
 * Retuns parsed url hash
 * @returns {object} hash
 */
function parseUrlHash () {
  const hash = window.location.hash.substring(2)
  const params = {}

  if (hash.length > 0) {
    const queryStrings = hash.split('&')
    queryStrings.map(hash => {
      const [key, val] = hash.split('=')
      params[key] = decodeURIComponent(val)
    })
  }

  return params
}

export default parseUrlHash



// WEBPACK FOOTER //
// ./src/utils/parse-url-hash.js